import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconCostOptimization: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.5 3.875C16.5 2.93219 16.5 2.46079 16.2071 2.16789C15.9142 1.875 15.4428 1.875 14.5 1.875H3.5C2.55719 1.875 2.08579 1.875 1.79289 2.16789C1.5 2.46079 1.5 2.93219 1.5 3.875V4.375C1.5 5.31781 1.5 5.78921 1.79289 6.08211C2.08579 6.375 2.55719 6.375 3.5 6.375H14.5C15.4428 6.375 15.9142 6.375 16.2071 6.08211C16.5 5.78921 16.5 5.31781 16.5 4.375V3.875Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 15.3863L5.37389 11.4726C5.75789 11.0846 6.38203 11.0763 6.77626 11.4538L8.5331 13.1363L10.778 9.77869C11.1574 9.21119 11.9814 9.18229 12.3996 9.72182L13.875 11.625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.5 5.25V15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M1.5 3.75L1.5 11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M4.88086 16.125H16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M6.375 4.125H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M3.75 4.12402H4.12501" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
